// @file Generate safe methods for localStorage and sessionStorage
interface SafeStorage {
  getItem: (item: string) => string | null
  setItem: (item: string, value: string) => boolean
  removeItem: (item: string) => boolean
}

function getSafeStorage(type: 'sessionStorage' | 'localStorage' = 'localStorage'): SafeStorage {
  const getStorage = () => (type === 'sessionStorage' ? sessionStorage : localStorage)
  return {
    getItem: (item: string): string | null => {
      try {
        return getStorage().getItem(item)
      } catch (_e) {
        return null
      }
    },
    setItem: (item: string, value: string) => {
      try {
        getStorage().setItem(item, value)
        return true
      } catch (_e) {
        return false
      }
    },
    removeItem: (item: string): boolean => {
      try {
        getStorage().removeItem(item)
        return true
      } catch (_e) {
        return false
      }
    },
  }
}

const safeLocalStorage: SafeStorage = getSafeStorage('localStorage')
const safeSessionStorage: SafeStorage = getSafeStorage('sessionStorage')
export { getSafeStorage, safeLocalStorage, safeSessionStorage }
